function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable react/display-name */
/* eslint react/prop-types: 0 */
import React from 'react';
import { Menu, Text } from 'grommet';
import ActionsCell from 'granite-admin/core/components/Table/ActionsCell';
import TextCell from 'granite-admin/core/components/Table/TextCell';
const EMPLOYEE_LIST_EVENTS = {
  LIST_START: 'LIST_START',
  LIST_SUCCESS: 'LIST_SUCCESS',
  LIST_FAILURE: 'LIST_FAILURE',
  UPDATE_SUCCESS: 'UPDATE_SUCCESS',
  UPDATE_FAILURE: 'UPDATE_FAILURE',
  DELETE_SUCCESS: 'DELETE_SUCCESS',
  DELETE_FAILURE: 'DELETE_FAILURE',
  STATUS_CHANGE_SUCCESS: 'STATUS_CHANGE_SUCCESS',
  STATUS_CHANGE_FAILURE: 'STATUS_CHANGE_FAILURE',
  INVITE_SUCCESS: 'INVITE_SUCCESS',
  INVITE_FAILURE: 'INVITE_FAILURE',
  ROLES_FETCH_SUCCESS: 'ROLES_FETCH_SUCCESS',
  ROLES_FETCH_FAILURE: 'ROLES_FETCH_FAILURE'
};
const EMPLOYEE_EDIT_EVENTS = {
  SAVE_SUCCESS: 'SAVE_SUCCESS',
  SAVE_FAILURE: 'SAVE_FAILURE',
  FETCH_SUCCESS: 'FETCH_SUCCESS',
  FETCH_FAILURE: 'FETCH_FAILURE',
  ADDRESS_SAVE_SUCCESS: 'ADDRESS_SAVE_SUCCESS',
  ROLES_FETCH_SUCCESS: 'ROLES_FETCH_SUCCESS',
  ROLES_FETCH_FAILURE: 'ROLES_FETCH_FAILURE',
  BUSINESS_ADMIN_ROLES_FETCH_SUCCESS: 'BUSINESS_ADMIN_ROLES_FETCH_SUCCESS',
  BUSINESS_ADMIN_ROLES_FETCH_FAILURE: 'BUSINESS_ADMIN_ROLES_FETCH_FAILURE'
};

// const EMPLOYEE_BULK_EVENTS = {
//   DELETE_BULK_SUCCESS: 'DELETE_BULK_SUCCESS',
//   DELETE_BULK_FAILURE: 'DELETE_BULK_FAILURE',
// }

const ONBOARDING_EVENTS = {
  ONBOARDING_SUCCESS: 'ONBOARDING_SUCCESS',
  ONBOARDING_FAILURE: 'ONBOARDING_FAILURE',
  COMPANY_TYPES_FETCH_SUCCESS: 'COMPANY_TYPES_FETCH_SUCCESS',
  COMPANY_TYPES_FETCH_FAILURE: 'COMPANY_TYPES_FETCH_FAILURE'
};
const ROLE_EVENTS = {
  ROLE_CREATION_SUCCESS: 'ROLE_CREATION_SUCCESS',
  ROLE_CREATION_FAILURE: 'ROLE_CREATION_FAILURE',
  ROLE_EDIT_SUCCESS: 'ROLE_EDIT_SUCCESS',
  ROLE_EDIT_FAILURE: 'ROLE_EDIT_FAILURE',
  GET_SUCCESS: 'GET_SUCCESS',
  GET_FAILURE: 'GET_FAILURE',
  STOP_LOADER: 'STOP_LOADER',
  ROLE_DELETE_SUCCESS: 'ROLE_DELETE_SUCCESS',
  ROLE_DELETE_FAILURE: 'ROLE_DELETE_FAILURE'
};
const PERMISSION_EVENTS = {
  LIST_SUCCESS: 'LIST_SUCCESS',
  LIST_FAILURE: 'LIST_FAILURE'
};
const ORGANISATION_EVENTS = {
  PROFILE_SAVE_SUCCESS: 'PROFILE_SAVE_SUCCESS',
  PROFILE_SAVE_FAILURE: 'PROFILE_SAVE_FAILURE',
  SETTINGS_FETCH_SUCCESS: 'SETTINGS_FETCH_SUCCESS',
  SETTINGS_FETCH_FAILURE: 'SETTINGS_FETCH_FAILURE',
  SETTINGS_SAVE_SUCCESS: 'SETTINGS_SAVE_SUCCESS',
  SETTINGS_SAVE_FAILURE: 'SETTINGS_SAVE_FAILURE',
  COMPANY_TYPES_FETCH_SUCCESS: 'COMPANY_TYPES_FETCH_SUCCESS',
  COMPANY_TYPES_FETCH_FAILURE: 'COMPANY_TYPES_FETCH_FAILURE'
};
const COLUMNS = [
// {
//   accessor: 'selection',
//   Header: ({getToggleAllRowsSelectedProps}) => (
//     <span title={'Select All'}>
//       <HeaderCheckBox {...getToggleAllRowsSelectedProps()} id="header" />
//     </span>
//   ),
//   Cell: ({row}) => (
//     <span title={'Select'}>
//       <CheckBox {...row.getToggleRowSelectedProps()} />
//     </span>
//   ),
//   disableSortBy: true,
// },

// {
//   accessor: 'pk',
//   Header: 'ID',
//   Cell: ({ cell: { value }, ...rest }) => <TextCell {...rest} data={value} />,
// },
{
  accessor: 'actions',
  Header: 'Actions',
  Cell: ({
    cell: {
      value,
      row
    },
    ...rest
  }) => {
    let actions = value;
    if (row?.original.isOwner) {
      actions = value.filter(i => i.name !== 'delete');
    }
    return /*#__PURE__*/React.createElement(ActionsCell, _extends({}, rest, {
      data: actions
    }));
  },
  disableSortBy: true,
  width: '280'
}, {
  id: 'name',
  accessor: 'name',
  Header: 'Name',
  Cell: ({
    cell: {
      value
    },
    ...rest
  }) => /*#__PURE__*/React.createElement(TextCell, _extends({}, rest, {
    data: value
  })),
  hideColumnsLabel: 'Name'
}, {
  id: 'user__email',
  accessor: 'email',
  Header: 'Email',
  Cell: ({
    cell: {
      value
    },
    ...rest
  }) => /*#__PURE__*/React.createElement(TextCell, _extends({}, rest, {
    data: value
  })),
  hideColumnsLabel: 'Email'
}, {
  id: 'designation',
  accessor: 'designation',
  Header: 'Designation',
  Cell: ({
    cell: {
      value
    },
    ...rest
  }) => /*#__PURE__*/React.createElement(TextCell, _extends({}, rest, {
    data: value,
    columnId: "designation"
  })),
  isEditable: true,
  hideColumnsLabel: 'Designation'
}, {
  id: 'is_active',
  accessor: 'isActive',
  Header: 'Status',
  disableSortBy: true,
  Cell: ({
    cell: {
      value,
      row,
      column
    },
    updateCellData,
    ...rest
  }) => /*#__PURE__*/React.createElement(TextCell, _extends({}, rest, {
    data: /*#__PURE__*/React.createElement(Menu, {
      disabled: row?.original.isOwner,
      size: "small",
      label: /*#__PURE__*/React.createElement(Text, null, value ? 'Active' : 'Inactive'),
      dropProps: {
        restrictFocus: false
      },
      items: [{
        label: value ? 'Inactive' : 'Active',
        onClick: () => updateCellData(row.original, 'isActive', !value)
      }]
    })
  }))
  // hideColumnsLabel: 'Status'
}];

const ORGANISATION_COLUMNS = [{
  Header: 'Action',
  accessor: 'actions',
  Cell: ({
    cell: {
      value
    },
    ...rest
  }) => /*#__PURE__*/React.createElement(ActionsCell, _extends({}, rest, {
    data: value
  })),
  disableSortBy: true,
  width: 50,
  minWidth: 50,
  maxWidth: 50,
  canResize: false,
  disableResizing: true,
  disableOrdering: true
},
// {
//   Header: 'ID',
//   accessor: 'pk',
//   // Cell: ({ cell: { value }, ...rest }) => <TextCell {...rest} data={value} />,
//   disableSortBy: true,
// },
{
  Header: 'Name',
  accessor: 'name',
  // Cell: ({ cell: { value }, ...rest }) => <TextCell {...rest} data={value} />,
  hideColumnsLabel: 'Name'
}, {
  Header: 'Email',
  accessor: 'email',
  disableSortBy: true,
  hideColumnsLabel: 'Email'
}, {
  Header: 'Phone',
  accessor: 'phone.phone',
  disableSortBy: true,
  hideColumnsLabel: 'Phone'
}, {
  Header: 'Billing Plan',
  accessor: 'billingPlan',
  disableSortBy: true,
  hideColumnsLabel: 'Billing Plan'
}];
export { EMPLOYEE_LIST_EVENTS, EMPLOYEE_EDIT_EVENTS,
// EMPLOYEE_BULK_EVENTS,
ONBOARDING_EVENTS, COLUMNS, ROLE_EVENTS, PERMISSION_EVENTS, ORGANISATION_EVENTS, ORGANISATION_COLUMNS };